// extracted by mini-css-extract-plugin
export var searchForm = "SearchForm-module--search-form--wGwPI";
export var searching = "SearchForm-module--searching--jOKAX";